import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { renderStructuredContent } from '../../renderContext';
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../types';
export type LiProps = StructuredContentDocumentWithRenderer<{
  children: StructuredContentDocument;
}>;
export const Li = t0 => {
  const $ = _c(5);
  const {
    props
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = css({
      "&:not(:first-of-type)": {
        marginTop: "2"
      }
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== props.children) {
    t2 = renderStructuredContent(props.children);
    $[1] = props.children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <li className={t1}>{t2}</li>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};